import { render, staticRenderFns } from "./Child.vue?vue&type=template&id=f0bd91d6&scoped=true&"
import script from "./Child.vue?vue&type=script&lang=js&"
export * from "./Child.vue?vue&type=script&lang=js&"
import style0 from "./Child.vue?vue&type=style&index=0&id=f0bd91d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bd91d6",
  null
  
)

export default component.exports